<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

        <v-progress-circular v-if="Loader" :size="70" :width="7" color="teal" indeterminate></v-progress-circular>

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <v-flex xs12 sm412 md12>
              <v-select
                label="Procurement Type"
                item-text="name"
                item-value="id"
                v-model="formSchema.procurement_type_id"
                :items="procurement_type_list"
                :rules="[(v) => !!v || 'Field is required']"
                required
                @change="setLabel($event)"
              ></v-select>
            </v-flex>
             <v-flex xs12 sm4 md6>
              <v-text-field
                label="Package Name"
                v-model="formSchema.name"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-text-field>
            </v-flex>

           <v-flex xs12 sm4 md6>
              <v-text-field
                label="Package Number"
                v-model="formSchema.package_no"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md6 v-if="contact_type">
              <v-select
                label="Contract Type"
                item-text="name"
                item-value="id"
                v-model="formSchema.contract_type"
                :items="contract_type_list"
                :rules="[rules.customRules(dynamicType, formSchema.contract_type)]"
                
              ></v-select>
            </v-flex>
           
            <v-flex xs12 sm4 md6>
              <v-select
                label="Measurement Unit"
                item-text="name"
                item-value="id"
                v-model="formSchema.unit_id"
                :items="unit_list"
            
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4 md6>
              <v-text-field
                label="Quantity"
                v-model="formSchema.quantity"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md6>
              <DatePicker
                :key="formSchema.id"
                :inputData="{
                  index: 1,
                  fieldName: 'from_date',
                  fieldValue: formSchema.from_date,
                  label: 'Work Start Date',
                }"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

           
            <v-flex xs12 sm4 md6 v-show="isTypeG">
              <DatePicker
                :key="formSchema.id"
                :inputData="{
                  index: 2,
                  fieldName: 'to_date',
                  fieldValue: formSchema.to_date,
                  label: 'Procurement End Date',
                }"
                @setValue="setDateValue"
                ref="setRange"
              ></DatePicker>
            </v-flex>
            <v-flex xs12 sm4 md6 v-show="isTypeS">
              <DatePicker
                :key="formSchema.id"
                :inputData="{
                  index: 2,
                  fieldName: 'to_date',
                  fieldValue: formSchema.to_date,
                  label: 'Indicative Completion Date',
                }"
                @setValue="setDateValue"
                ref="setRange"
              ></DatePicker>
            </v-flex>
             <v-flex xs12 sm4 md6>
              <v-text-field
                label="Estimated Price (BDT)"
                v-model="formSchema.estimated_price"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-text-field>
            </v-flex>
            </v-flex>
             <v-flex xs12 sm4 md6>
              <v-text-field
                label="USD Rate"
                v-model="formSchema.es_currency_rate"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm4 md6>
              <v-select
                label="Method"
                item-text="name"
                item-value="id"
                v-model="formSchema.method_id"
                :items="method_list"
                :rules="[(v) => !!v || 'Field is required']"
                @change="setStepDetail($event)"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4 md6>
              <v-select
                label="Status"
                item-text="name"
                item-value="id"
                v-model="formSchema.status_id"
                :items="status_list"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm4 md6>
              <v-text-field
                label="Beneficiary Name"
                v-model="formSchema.beneficiary_name"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm4 md6>
              <v-select
                label="Prior Review"
                item-text="name"
                item-value="id"
                v-model="formSchema.prior_rev"
                :items="prior_review"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4 md6>
              <v-select
                label="Source of Fund"
                item-text="name"
                item-value="id"
                v-model="formSchema.fund_sources"
                :items="fund_source_data"
                :rules="[(v) => !!v || 'Field is required']"
              ></v-select>
            </v-flex>  

            <v-flex xs12 sm4 md12>
              <v-text-field
                label="Remarks"
                v-model="formSchema.remarks"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="submitPackageDetail">
        Save & Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
      <v-btn color="secondary" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn color="warning"  @click.native="directNextStep">Next  <v-icon>arrow_forward_ios</v-icon></v-btn>
    </v-card-actions>
  </div>
</template>

<script>
const commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";

export default {
  components: {
    DatePicker,
  },
  data: () => ({
    valid: true,
    e1: 0,
    show: false,
    Loader: false,
    package_info_id: sessionStorage.getItem("package_info"),

    unit_list: [],
    method_list: [],
    procurement_type_list: [],
    contract_type_list: [],
    status_list: [
      { id: "1", name: "Plan" },
      { id: "4", name: "Merge" },
      { id: "5", name: "Split" }
    ],
    prior_review: [
      { id: 1, name: "Yes" },
      { id: 0, name: "No" },
    ],
    fund_source_data: [
      { id: 'GOB', name: "GOB" },
      { id: 'IDA', name: "IDA" },
    ],

    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",
    contact_type:true,
    formSchema: {
      id: "",
      package_no:"",
      name: "",
      from_date: "",
      to_date: "",
      procurement_type_id: "",
      beneficiary_name: "",
      quantity: "",
      unit_id: "",
      estimated_price: "",
      es_currency_rate: "",
      method_id: "",
      prior_rev:0,
      fund_sources:"",
      status_id: "",
      contract_type: "",
      remarks: ""
    },
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    dynamicLabel:'test',
    dynamicType:'',
    isTypeG:true,
    isTypeS:false,
    rules:{
      customRules: (i,j) => {
        
        if (i.match(/serv/gi) && j == "") {
          return (
            false ||
            "Contract Type is required"
          );
        } else {
          return true;
        }
        
      }
    },
    
  }),

  created() {
    if (this.package_info_id) {
      this.loadData();
    }
    commonService.getAllData("proc_methods_list").then((res) => {
      this.method_list = res.data;
    });
    commonService.getAllData("proc_unit_list").then((res) => {
      this.unit_list = res.data;
    });
    commonService.getAllData("proc_get_types").then((res) => {
      this.procurement_type_list = res.data;
    });
    commonService.getAllData("proc_get_contract").then((res) => {
      this.contract_type_list = res.data;
    });
  },
  watch:{
    dynamicLabel(newVal, oldVal){
        this.dynamicLabel = newVal
        return this.dynamicLabel
    }
  },

  methods: {
    setLabel(key){ 
      var unit = this.unit_list = [];
       let type = this.procurement_type_list.find((current)=> key == current.id)
       this.dynamicType = type.name;
       if(type.name == 'Goods'){
         this.dynamicLabel = 'Contract End Date'
         this.isTypeG = true
         this.isTypeS = false
         this.contact_type = false;
         commonService.getAllData("proc_unit_list").then((res) => {
          res.data.forEach(function(input) {
            if(input.p_type_id === key){  
              unit.push(input);
            } 
          });
          this.unit_list = unit;
         });

       }
       if(type.name == 'Services'){
         this.dynamicLabel = 'Indicative Completion Date'
         this.isTypeG = false
         this.isTypeS = true
         this.contact_type = true;
         commonService.getAllData("proc_unit_list").then((res) => {
          res.data.forEach(function(input) {
            if(input.p_type_id === key){  
              unit.push(input);
            }
          });
          this.unit_list = unit;
         });
       }

     },
    setRules(id){
      //  console.log(id)
    },
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
       if(data.fieldName == "from_date"){
        this.formSchema.end_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },
    loadData() {
      let formSchema = this.formSchema;
      commonService
        .getAllDataById(this.package_info_id, "proc_packages")
        .then((res) => {
          if (res.data) {
            this.formSchema = res.data;

            this.formSchema.from_date = this.changeFormateDMY(
              res.data.from_date
            );
            this.formSchema.to_date = this.changeFormateDMY(res.data.to_date);
            //Procurement Type Show Hide for edit  
            if(res.data.procurement_type_id == 1){
              this.contact_type = false;
            }else{
              this.contact_type = true;
            }
            this.formSchema.contract_type = parseInt(res.data.contract_type)
            // console.log("this.formSchema = ", this.formSchema);
            if(sessionStorage.getItem("is_edit") != true){ 
                this.formSchema.status_id = '1';
            }
          }
          this.show = true;
        });
        
    },
    setStepDetail(e) {
      this.$emit("setMethodId", e);
    },


    submitPackageDetail() {
      //this.nextStep();
      var is_edit = sessionStorage.getItem("is_edit");
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;
      formSchema.module = sessionStorage.getItem("mm_id");
      formSchema.menu = sessionStorage.getItem("sm_id");
      formSchema.from_date = root.changeFormateYMD(this.formSchema.from_date);
      formSchema.to_date = root.changeFormateYMD(this.formSchema.to_date);

      formSchema.is_edit = is_edit;
      if (this.$refs.form.validate()) { 

      if ((formSchema.id > 0) && (is_edit == 'true')) { 
        commonService
          .updateFormData(formSchema, "proc_packages")
          .then((res) => {
            if (res.status == 1) {
              this.Loader = true;
               this.SnackbarVal.color = "success";
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;
              this.$emit("setPackageId", res.data.id);
              this.$emit("setMethodId", res.data.method_id);
              sessionStorage.setItem("package_info", res.data.id);
              sessionStorage.setItem("method_info", res.data.method_id);
              setTimeout(function() {
                root.nextStep();
              }, 3000);
            }else{
               this.Loader = false
               this.SnackbarVal.color = "error";
               this.SnackbarVal.message = res.message;
               this.SnackbarVal.snackbar = true; 
            }
          });
      } else { 
        commonService
          .insertFormData(formSchema, "proc_packages")
          .then((res) => {
            if (res.status == 1) {
              // this.message ='Data created successfully!';
              // this.snackbar = true
              sessionStorage.setItem("package_info", res.data.id);
              this.$store.commit("updatePackageId", res.data.id);
              this.$store.commit("updateMethodId", res.data.method_id);

              this.$emit("setPackageId", res.data.id);
              this.$emit("setMethodId", res.data.method_id);
              this.SnackbarVal.color = "success";
              this.Loader = true;
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;

              setTimeout(function() {
                root.nextStep();
              }, 3000);
            }else{
               this.Loader = false
               this.SnackbarVal.color = "error";
               this.SnackbarVal.message = res.message;
               this.SnackbarVal.snackbar = true; 
            }
          });
      }
        }else{
           this.Loader = false
        }
      // Set Item Edit True----
      sessionStorage.setItem("is_edit",true);
    },

    nextStep() {
      this.Loader = false;
      this.$emit("emitForm1", 2);
    },

    directNextStep() {
      this.$emit("setPackageId", this.package_info_id);
      this.$emit("setMethodId", this.formSchema.method_id);
      sessionStorage.setItem("package_info", this.package_info_id);
      sessionStorage.setItem("method_info", this.formSchema.method_id);
      this.Loader = false;
      this.$emit("emitForm1", 2);
    },

    previous() {
      this.$emit("emitForm1", 1);
    },

    close: function() {
      this.$refs.form.reset();
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 10rem;
  position: absolute !important;
  left: 37%;
}
</style>



// WEBPACK FOOTER //
// src/components/procurement/package/step_forms/packageDetail.vue